export function Matched() {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="8" cy="8" r="8" fill="#007D23" />
			<path
				d="M4.57141 9.14287L7.42855 11.4286L11.4286 5.71429"
				stroke="white"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
